/** Every sale, and refunding one. */
const purchases = {
  en: {
    details: "Details",
    hideDetails: "Hide details",
    itemsLoading: "Loading…",
    itemsFailed: "Could not load the items.",
    noItems: "No items recorded.",
    qty: "Qty",
    title: "Purchases",
    subtitle: "Sales from the in-store register and from the customer app",
    loadFailed: "Could not load your sales.",
    refundFailed:
      "Could not refund that sale. Only the owner, or staff you have allowed, can refund.",
    empty: "No sales yet.",
    emptyPeriod: "No sales in this period.",
    count: { one: "{count} sale", other: "{count} sales" },
    columns: {
      date: "Date",
      source: "Source",
      customer: "Customer",
      payment: "Payment",
      amount: "Amount",
      status: "Status",
    },
    source: {
      pos: "🧾 Register",
      posNumber: "🧾 Register #{number}",
      app: "📱 App",
      preorder: "📦 Pre-order",
      preorderNumber: "📦 Pre-order #{number}",
    },
    refunded: "Refunded",
    refund: "Refund",
    reason: "Why? (optional)",
    confirmRefund: "Refund & return stock",
  },

  fr: {
    details: "Détails",
    hideDetails: "Masquer les détails",
    itemsLoading: "Chargement…",
    itemsFailed: "Impossible de charger les articles.",
    noItems: "Aucun article enregistré.",
    qty: "Qté",
    title: "Ventes",
    subtitle: "Les ventes de la caisse en boutique et de l'application client",
    loadFailed: "Impossible de charger vos ventes.",
    refundFailed:
      "Impossible de rembourser cette vente. Seul le propriétaire, ou un employé autorisé, peut rembourser.",
    empty: "Aucune vente pour l'instant.",
    emptyPeriod: "Aucune vente sur cette période.",
    count: { one: "{count} vente", other: "{count} ventes" },
    columns: {
      date: "Date",
      source: "Origine",
      customer: "Client",
      payment: "Paiement",
      amount: "Montant",
      status: "Statut",
    },
    source: {
      pos: "🧾 Caisse",
      posNumber: "🧾 Caisse n° {number}",
      app: "📱 Appli",
      preorder: "📦 Précommande",
      preorderNumber: "📦 Précommande n° {number}",
    },
    refunded: "Remboursée",
    refund: "Rembourser",
    reason: "Pourquoi ? (facultatif)",
    confirmRefund: "Rembourser et remettre en stock",
  },

  ar: {
    details: "التفاصيل",
    hideDetails: "إخفاء التفاصيل",
    itemsLoading: "جارٍ التحميل…",
    itemsFailed: "تعذّر تحميل المنتجات.",
    noItems: "لا توجد منتجات مسجلة.",
    qty: "الكمية",
    title: "المبيعات",
    subtitle: "مبيعات نقطة البيع في المتجر ومن تطبيق الزبائن",
    loadFailed: "تعذّر تحميل مبيعاتك.",
    refundFailed:
      "تعذّر استرداد هذه العملية. لا يمكن الاسترداد إلا للمالك أو لموظف مخوّل.",
    empty: "لا توجد مبيعات بعد.",
    emptyPeriod: "لا توجد مبيعات في هذه الفترة.",
    count: {
      zero: "لا مبيعات",
      one: "عملية بيع واحدة",
      two: "عمليتا بيع",
      few: "{count} عمليات بيع",
      many: "{count} عملية بيع",
      other: "{count} عملية بيع",
    },
    columns: {
      date: "التاريخ",
      source: "المصدر",
      customer: "الزبون",
      payment: "الدفع",
      amount: "المبلغ",
      status: "الحالة",
    },
    source: {
      pos: "🧾 نقطة البيع",
      posNumber: "🧾 نقطة البيع #{number}",
      app: "📱 التطبيق",
      preorder: "📦 طلب مسبق",
      preorderNumber: "📦 طلب مسبق #{number}",
    },
    refunded: "مستردّة",
    refund: "استرداد",
    reason: "السبب؟ (اختياري)",
    confirmRefund: "استرداد وإرجاع المخزون",
  },
};

export default purchases;
